import axios from "axios";

// API_URL removed — axiosInstance uses relative URLs that route through Nginx in all environments
export const jwtPrivateKey = "accessdoorsecret";

// Utility to get current auth headers dynamically
export const getHeaders = () => {
  const token = sessionStorage.getItem("jwtToken");
  const headers: Record<string, string> = {};
  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }
  return headers;
};

export const axiosConfig: any = {
  get headers() {
    return getHeaders();
  }
};

// Ensure all generic axios calls send the HTTP-Only cookie back to the server
axios.defaults.withCredentials = true;

export const axiosInstance = axios.create({
  withCredentials: true,
  // No baseURL — relative paths like /api/role go through Nginx in all environments
  headers: {
    'content-type': 'application/json',
  },
});


// Add a request interceptor to include the auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("jwtToken");
    if (token && config.headers) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ── Global 401 Response Interceptor ──────────────────────────────────────────
// If ANY API call returns 401 Unauthorized (e.g. after an idle logout clears
// the token), silently clear the session and redirect to /login instead of
// letting the rejected promise surface as an uncaught runtime error in the UI.
const handle401 = (error: any) => {
  if (error?.response?.status === 401) {
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("loggedinUser");
    // Hard redirect — works even if the React Router history isn't in scope here
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
      // Return a never-resolving promise only during active redirection
      // to prevent uncaught rejection overlay overlays from surfacing.
      return new Promise(() => {});
    }
  }
  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
  (response) => response,
  handle401
);

// Apply the same 401 guard to all plain axios() calls used across the app
axios.interceptors.response.use(
  (response) => response,
  handle401
);
